module.exports = __webpack_public_path__ + "static/media/logo.fa8484ed.png";